import React from 'react';

export function TooltipLabel({ label, tooltip, htmlFor }) {
  return (
    <label htmlFor={htmlFor} className="tooltip-label">
      <span>{label}</span>
      <span
        className="field-tooltip"
        tabIndex={0}
        role="button"
        aria-label={`Nápověda: ${label}`}
      >
        i
        <span className="field-tooltip-bubble">{tooltip}</span>
      </span>
    </label>
  );
}
